import React, { useMemo } from 'react'

import BaseInfoCard from '../BaseInfoCard'
import NoData from '../BaseInfoCard/NoData'
import ResultItem from '../BaseInfoCard/ResuleItem'
import Loading from 'components/Loading'
import _ from 'lodash'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'

import useMyHealthPolicyByModel from 'hooks/useMyHealthPolicy'
import SthWentWrong from 'containers/MyHealth/components/MyHealthContentArea/SthWentWrong'

import { parseMedications } from '@enlyt/helpers/parse'
import { sortMedications } from '@web/helpers/sortBy'

import MedicationsSvg from 'images/custom/icons/eh-icon-medications.svg'

const Medications = (props) => {
  const { theme, isDark } = useTheme()
  const styles = themeStyles(theme)
  const {
    loading, data, linkTo, name, error
  } = props
  const icon = isDark ? props.iconDark : props.icon
  const sthStyle = { backgroundColor: 'transparent', height: '100%' }

  const items = useMemo(() => {
    const medications = parseMedications(sortMedications(data))
    return medications.slice(0, 2).map((m) => {
      return {
        title: m.title,
        subTitle: m.patientInstruction,
        date: m.authoredOn
      }
    })
  }, [data])

  const adolescent = !useMyHealthPolicyByModel('medications')

  return (
    <BaseInfoCard title={name} loading={loading} icon={icon} style={styles} linkTo={linkTo}>
      {adolescent && <NoData />}
      {!adolescent && loading && _.isEmpty(items) && <Loading />}
      {!adolescent && (!_.isEmpty(items)
        ? items.map((item, index) => (
          <ResultItem key={index} iconGray={<MedicationsSvg />} iconSize={20} {...item} isLast={index === items.length - 1} />))
        : error ? <SthWentWrong style={{ container: sthStyle }} /> : <NoData text={name} />)}
    </BaseInfoCard>
  )
}

export default Medications
